import { render, staticRenderFns } from "./BottomNavigation.vue?vue&type=template&id=5f5ae324"
import script from "./BottomNavigation.vue?vue&type=script&setup=true&lang=ts"
export * from "./BottomNavigation.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f5ae324')) {
      api.createRecord('5f5ae324', component.options)
    } else {
      api.reload('5f5ae324', component.options)
    }
    module.hot.accept("./BottomNavigation.vue?vue&type=template&id=5f5ae324", function () {
      api.rerender('5f5ae324', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout/BottomNavigation.vue"
export default component.exports